import React from "react";
import "./ErrorBoundary.css";

/**
 * Catches render/lifecycle errors in the tree below it so an unexpected exception shows a
 * recoverable message instead of a blank white screen. Must be a class component — React has
 * no hook equivalent for componentDidCatch / getDerivedStateFromError.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface to the console (and any attached monitoring) without leaking to the UI.
    // eslint-disable-next-line no-console
    console.error("Unhandled UI error:", error, info?.componentStack);
  }

  handleReload = () => {
    if (typeof window !== "undefined") {
      window.location.assign("/");
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <section className="errorboundary-root" role="alert">
          <h1 className="errorboundary-title">Something went wrong</h1>
          <p className="errorboundary-text">
            An unexpected error occurred. Please try again.
          </p>
          <button
            type="button"
            className="errorboundary-button"
            onClick={this.handleReload}
          >
            Reload
          </button>
        </section>
      );
    }
    return this.props.children;
  }
}
